<!-- админская топ-панель: уведомления + превью палитр — самый верх страницы, видит только админ -->
<app-admin-pending-bar/>

<header class="bg-card">

  <app-container>

    <div class="flex flex-wrap items-center justify-between">
      <div class="flex flex-wrap items-center gap-2.5 py-2.5">
        <a class="font-semibold text-right" routerLink="/">
          <div class="text-xs">Интересное на</div>
          <div>{{ environment.websiteName }}</div>
        </a>
        <a [routerLink]="['/', r.blogs]">Все материалы</a>
        <a [routerLink]="['/', r.catNested]">Разделы</a>
        @if (settings.coursesEnabled()) {
          <a [routerLink]="['/', r.courses]">Курсы</a>
        }
        <a [routerLink]="['/', r.calcs]">Калькуляторы</a>
        <a [routerLink]="['/', r.userscripts]">Скрипты</a>
      </div>

      <div class="flex flex-wrap items-center gap-2.5 py-2.5">

        <button hlmBtn variant="ghost" size="icon" type="button"
                (click)="theme.toggle()"
                [title]="theme.isDark() ? 'Светлая тема' : 'Тёмная тема'"
                [attr.aria-label]="theme.isDark() ? 'Включить светлую тему' : 'Включить тёмную тему'">
          {{ theme.isDark() ? '☀️' : '🌙' }}
        </button>

        @if (authReady) {
          @if (authService.isLogged()) {
          <!-- <a [routerLinkActiveOptions]="{exact: true}" -->
          <!--    [routerLink]="['/', r.account, r.accountPremium]" -->
          <!--    class="btn btn-warning" -->
        <!--    routerLinkActive="btn-outline">Подписка</a> -->
        @if (authService.user?.userType == UserType.Admin) {
          <a [routerLinkActiveOptions]="{exact: true}"
            [routerLink]="['/', r.admin, r.blogs, r.add]"
            hlmBtn
            routerLinkActive="btn-outline"
          >📝 Добавить пост</a>
          <a [routerLinkActiveOptions]="{exact: true}"
            [routerLink]="['/', r.admin]"
            hlmBtn
            routerLinkActive="btn-outline"
          >😎 Админ</a>
        }
        <a [routerLinkActiveOptions]="{exact: true}"
          [routerLink]="['/', r.account]"
          hlmBtn
          routerLinkActive="btn-outline"
        >Аккаунт</a>
        <button (click)="authService.logout()" hlmBtn variant="destructive">Выйти</button>
      }

          @if (!authService.isLogged()) {
            <!-- keep ?returnUrl= when switching between login and register (#1055) -->
            <a [routerLink]="['/', r.login]" [queryParams]="authQuery()" hlmBtn variant="outline">Вход</a>
            <a [routerLink]="['/', r.register]" [queryParams]="authQuery()" hlmBtn>Регистрация</a>
          }
        }


    </div>
  </div>

</app-container>


</header>

<!-- тикер курсов крипты: лента топ-монет с ценой в ₽ -->
<app-crypto-ticker/>

<!-- warning message -->
<!-- <div style="margin-top: 30px;">
<app-container>
  <app-card>
    <div style="cursor: pointer;">
      <app-card-header (click)="showWarning()"
        [bgColor]="'#ff7070'">
        ⚠️ Информация об ошибке! Развернуть!
      </app-card-header>
    </div>
    <app-card-body *ngIf="isWarning">
      <div style="text-align: center; color: red;padding: 20px;">
        <p style="font-size: 32px; font-weight: 700">В данный момент мы ведём работы над восстановлением сайта,
          приносим Вам свои
        извинения.</p>
        <p>Будьте добры, посетите сайт немного позднее, с сайтом в данный момент есть проблемы, мы о них знаем и
        работаем над этим. </p>
        <p>Приносим Вам свои извинения.</p>

        <p style="font-size: 38px">😭</p>

        <div style="display: block;">
          <button type="button" style="margin: 0 auto;"
            class="btn" (click)="hideWarning()">
            OK!
          </button>
        </div>
      </div>
    </app-card-body>
  </app-card>
</app-container>
</div> -->
<!-- end warning message -->



